import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CountdownTimer from "../../Components/CountdownTimer";
import { toast } from "react-toastify";
import { FaWhatsapp } from "react-icons/fa6";
import { MdOutlineSms } from "react-icons/md";
import NodeaxiosInstance from "../../Services/nodeaxios";
import { useUser } from "../../Components/UserContext";
import { showToast } from "../../Components/toastConfig/ToastConfig";
import UserLogo from "../../Assets/Images/LogoUser.png"
import topBanaer from "../../Assets/Images/user_login_screen_top.png"
import { useDispatch } from "react-redux";
import { addUserToken } from "../../redux/slices/userTokenSlice";


const OtpVerification = () => {

    const dispatch = useDispatch()
    const [otpError, setOTPError] = useState("");
    const [showResendOTP, setShowResendOTP] = useState(false);
    const [resendOTPType, setResendOTPType] = useState();
    const { appUser, setUser } = useUser();
    const [triggerTimer, setTriggerTimer] = useState(false);
    const countDownTimerRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();
    const { flow } = location.state || {};
    const vendorUrl = localStorage.getItem("vendorUrl");
    const [isLoading, setLoadingStatus] = useState(false);
    const [shoeRecentOTPOption, setShowResendOTPOption] = useState(false)
    const [otp, setOTP] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [editmodalOpen, setEditModalOpen] = useState(false);
    const [userPhoneNumber, setUserPhoneNumber] = useState(appUser?.user_mbl || location?.state?.mobileNumber)
    const [whatsappisLoading, setWhatsappLoadingStatus] = useState(false);
    const [smsisLoading, setSmsLoadingStatus] = useState(false);
    const [btnloadingStatus, setBtnLoadingStatus] = useState()

    const [email, setEmail] = useState()
    // 0 while a signup is still pending, 1 for an account that only needs
    // its email verified. Decides where the add-email modal continues to.
    const [pendingRegStatus, setPendingRegStatus] = useState()


    useEffect(() => {

        let check = localStorage.getItem("login");
        if (check == "Register") {
            navigate('/');
        }
        if (check == "logged") {
            navigate('/');
        }
    }, []);


    const resendOTP = (type) => {
        let body = {
            "phoneNumber": userPhoneNumber || appUser?.user_mbl || location?.state?.mobileNumber,
            "type": type,
        };

        NodeaxiosInstance.post('auth/login-resend-otp', body)
            .then((res) => {
                setTriggerTimer(triggerTimer => !triggerTimer);
                setShowResendOTP(false)
                setShowResendOTPOption(false)
                if (type == 1) {
                    setSmsLoadingStatus(false)
                } else {
                    setWhatsappLoadingStatus(false)
                }
            });
    }

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();

        if (otp.length !== 4) {
            toast("Please enter a valid 4-digit OTP", {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: true,
                theme: "light",
                className: "text-danger toast-style-1"
            });
            return;
        }
        setLoadingStatus(true);
        try {
            //  Verify OTP
            const phoneNumber = userPhoneNumber || appUser?.user_mbl || location?.state?.mobileNumber;

            const otpRes = await NodeaxiosInstance.post("auth/login-verify-otp", {
                phoneNumber,
                otp: otp.join(""),
                device_token: " "
            });

            let userData = otpRes?.data?.user_details;

            let userDate = {
                'token': otpRes?.data?.token,
                'user_type': otpRes?.data?.user_type,
                'user_id': otpRes?.data?.user_id,
                'user_reg_status': userData?.user_reg_status
            };
            dispatch(addUserToken(userDate))

            // Resume from what the server knows, not from local storage: the
            // signup may have been started on another device or after the app
            // data was cleared, in which case appUser is gone.
            const pendingEmail = userData?.user_email || appUser?.user_email;

            if (!pendingEmail) {
                setPendingRegStatus(userData?.user_reg_status)
                setModalOpen(true)
            }
            else if (userData?.user_email_status == 0) {
                // Registration is only finalised after the email is verified, so
                // both an unfinished signup and an unverified login land here.
                const flow = userData?.user_reg_status == 0 ? undefined : 'emailverify';
                setUser({ ...(appUser || {}), user_email: pendingEmail, user_mbl: phoneNumber });
                navigate("/code-verification", { state: { email: pendingEmail, flow } });
                NodeaxiosInstance.post("auth/send-email-otp", { email: pendingEmail }).catch(console.error);
            }
            else if (userData?.user_reg_status == 0) {
                // Email is verified but the account was never activated.
                await NodeaxiosInstance.post("auth/register-user", {});
                dispatch(addUserToken({ ...userDate, user_reg_status: 1 }));
                localStorage.setItem("login", 'logged');
                navigate(vendorUrl ? vendorUrl : '/')
            }
            else {
                localStorage.setItem("login", 'logged');
                navigate(vendorUrl ? vendorUrl : '/')
            }
        } catch (error) {
            const message = error?.response?.data?.message ||
                error?.message || "Something went wrong";

            showToast(message, {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: true,
                theme: "light",
                className: "text-danger toast-style-1"
            });
        } finally {
            setLoadingStatus(false);
        }
    };



    const inputsRef = useRef([]);
    const numInputs = 4;

    const handleChange = (value, index) => {
        const digits = value.replace(/\D/g, "");
        if (!digits) return;

        const newOtp = [...otp];

        // 🔥 If multiple digits entered (keyboard OTP or paste)
        digits.split("").forEach((digit, i) => {
            if (index + i < numInputs) {
                newOtp[index + i] = digit;
            }
        });

        setOTP(newOtp);

        const nextIndex = Math.min(index + digits.length, numInputs - 1);
        inputsRef.current[nextIndex]?.focus();
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            const newOtp = [...otp];

            if (newOtp[index]) {
                newOtp[index] = "";
                setOTP(newOtp);
            } else if (index > 0) {
                inputsRef.current[index - 1]?.focus();
            }
        }
    };


    const handlePaste = (e) => {
        e.preventDefault();

        const clipboardData = e.clipboardData || window.clipboardData;
        const pastedData = clipboardData.getData("Text");

        if (!pastedData) return;

        const digits = pastedData.replace(/\D/g, "").slice(0, numInputs);

        if (digits.length === 0) return;

        const newOtp = Array(numInputs).fill("");

        digits.split("").forEach((digit, index) => {
            newOtp[index] = digit;
        });

        setOTP(newOtp);

        const focusIndex = digits.length >= numInputs
            ? numInputs - 1
            : digits.length;

        inputsRef.current[focusIndex]?.focus();
    };

    const handelAddMailandsentOtp = async () => {
        try {
            setBtnLoadingStatus(true);

            const response = await NodeaxiosInstance.post("auth/send-email-otp", { email: email })

            if (response?.data?.status == 1) {
                const updatedUser = {
                    ...(appUser || {}),
                    user_email: email,
                    user_mbl: userPhoneNumber || appUser?.user_mbl
                };

                setUser(updatedUser);

                setModalOpen(false);
                // A signup still in progress finishes at register-user; an
                // existing account only needs the email verified.
                const flow = pendingRegStatus == 0 ? undefined : 'emailverify';
                navigate("/code-verification", { state: { email: email, flow } })
            }

        } catch (error) {
            showToast(error?.response?.data?.message || "Something went wrong", {
                className: "text-danger toast-style-1"
            });
        } finally {
            setBtnLoadingStatus(false);
        }
    };

    const handelEditUserMobileNum = async () => {
        try {
            setBtnLoadingStatus(true);

            const updatedUser = { ...(appUser || {}), user_mbl: userPhoneNumber };
            setUser(updatedUser);

            const reqData = {
                phoneNumber: userPhoneNumber,
                type: 2
            };

            const response = await NodeaxiosInstance.post("auth/signup-phone-resend-otp", reqData);
            if (response?.data?.status == 1) {
                showToast(response?.data?.message || "OTP sent successfully", 'success');
                setEditModalOpen(false);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setBtnLoadingStatus(false);
        }
    };

    const checkBtnDisable = () => {
        return otp?.length != 4 || otp.some((digit) => !digit || digit.trim() == "");
    }




    return (
        <>
            <div className=" bg-white ">
                <div className="position-relative">
                    <img src={topBanaer} height="110px" width="100%" />
                    <img src={UserLogo} height="80px" width="80px" className="rounded-3 position-absolute top-100 start-50 translate-middle  mb-2 " />
                </div>
                <div className="loginPage p-0 vh-100 bg-white d-flex align-items-center">
                    <div className="px-3">
                        <div className="ff-poppins-bold fs-24 secondary-text">Enter OTP</div>
                        <div className="ff-poppins-light fs-14 secondary-text">We have sent you an SMS with a 4 digit Verification code for {userPhoneNumber}
                            {/* {
                                flow != 'normalLogin' && */}
                            <span className="primary-text ff-poppins-medium  ms-1" onClick={() => setEditModalOpen(true)}>(Edit)</span>
                            {/* } */}
                        </div>

                        <form className='mt-4 text-center' onSubmit={handleSubmit}>
                            <div className="d-flex justify-content-center">
                                <div className="flex" onPaste={handlePaste}>
                                    {Array.from({ length: numInputs }).map((_, index) => (
                                        <input key={index} ref={(el) => (inputsRef.current[index] = el)} type="text" value={otp[index]}
                                            onChange={(e) => handleChange(e.target.value, index)} onKeyDown={(e) => handleKeyDown(e, index)}
                                            inputMode="numeric" autoComplete="one-time-code"
                                            className="otp-input bg-transparent me-3 text-center ff-balooPaaji2-regular fs-40 primary-text"
                                            style={{ width: "3rem", height: "3rem", margin: "0 0.5rem", textAlign: "center", background: "transparent", fontSize: "2rem", color: "var(--primary-text-color)" }}
                                        />
                                    ))}
                                </div>

                            </div>
                            <span className="ff-poppins-regular fs-14 text-danger">{otpError}</span>

                            {!shoeRecentOTPOption && <div className="d-flex justify-content-center" >
                                <button type="submit" disabled={checkBtnDisable()} className={`${isLoading ? "loading" : ""}  ${checkBtnDisable() ? "opacity-40" : ""} primary-bg  w-100 border-0 rounded-pill 
                                     ff-poppins-semiBold fs-20 text-white mt-5 d-flex justify-content-center align-items-center`}>
                                    {
                                        isLoading
                                            ?
                                            <span className="loader-style-1"></span>
                                            :
                                            <span>Continue</span>
                                    }
                                </button>
                            </div>}
                            <div className="ff-poppins-light fs-16 text-center secondary-text-1 mt-3 pt-2">
                                {!shoeRecentOTPOption ?
                                    showResendOTP ?
                                        <span>
                                            Didn't receive OTP ?
                                            <span role="button" className="primary-text" onClick={() => {
                                                setShowResendOTPOption(!shoeRecentOTPOption)
                                                // resendOTP()
                                            }}> Click Here</span>
                                        </span>
                                        :
                                        <span>Resend OTP in 0:<CountdownTimer trigger={triggerTimer} triggerStart={() => setShowResendOTP(true)} /></span>
                                    : ""}
                            </div>
                        </form>
                        {shoeRecentOTPOption &&
                            <>
                                <button onClick={() => { resendOTP(2); setWhatsappLoadingStatus(true) }} className={(whatsappisLoading ? "loading" : "") + " " +
                                    `primary-bg   w-100 border-0 rounded-pill ff-poppins-semiBold fs-16 text-white mt-3 p-3 d-flex justify-content-center align-items-center`}>
                                    {
                                        whatsappisLoading
                                            ?
                                            <span className="loader-style-1"></span>
                                            :
                                            <div className="d-flex align-items-center">
                                                <span className="me-1"><FaWhatsapp size={22} /></span>
                                                <span> Get OTP via WhatsApp</span>
                                            </div>
                                    }
                                </button>

                                <button onClick={() => { resendOTP(1); setSmsLoadingStatus(true) }} className={(smsisLoading ? "loading" : "") + " " +
                                    ` primary-bg w-100 border-0 rounded-pill ff-poppins-semiBold fs-16 text-white mt-2 p-3 d-flex justify-content-center align-items-center`}>
                                    {
                                        smsisLoading ?
                                            <span className="loader-style-1"></span>
                                            :
                                            <div className="d-flex align-items-center">
                                                <span className="me-1"><MdOutlineSms size={20} /></span>
                                                <span>  Get OTP via SMS</span>
                                            </div>
                                    }
                                </button>
                            </>}

                        {modalOpen && (
                            <>
                                <div className="modal-backdrop fade show"></div>

                                <div className="modal fade show successModal" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-modal="true">
                                    <div className="modal-dialog modal-dialog-centered modal-sm m-0">
                                        <div className="modal-content">
                                            <div className="modal-body ps-4 pe-4 pt-3 pb-3 ">
                                                <div className='text-center ff-poppins-semiBold fs-14'>Enter E-mail</div>
                                                <input type="email" className="form-control rounded-0 border-0  text-dark no-spinners w-100 ff-poppins-medium fs-14 pe-5" name="user_email"
                                                    maxLength={45} value={email} placeholder="Enter the email id" onChange={(e) => (setEmail(e.target.value))} />
                                                <div className="d-flex justify-content-between mt-3">
                                                    <button type="button" className="loginAddemailModelBtn bg-secondary" onClick={() => setModalOpen(false)}>Cancel</button>
                                                    <button type="button" className="loginAddemailModelBtn primary-bg"
                                                        onClick={handelAddMailandsentOtp} disabled={btnloadingStatus}   >
                                                        {btnloadingStatus ? <span className="spinner-border spinner-border-sm" /> : "Done"}

                                                    </button>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                        {editmodalOpen && (
                            <>
                                <div className="modal-backdrop fade show"></div>

                                <div className="modal fade show successModal" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-modal="true">
                                    <div className="modal-dialog modal-dialog-centered modal-sm m-0">
                                        <div className="modal-content">
                                            <div className="modal-body ps-4 pe-4 pt-3 pb-3 ">
                                                <div className='text-center ff-poppins-semiBold fs-14'>Edit Phone Number</div>
                                                <input type="tel" className="form-control rounded-0 border-0 secondary-text-1 no-spinners w-100 ff-poppins-medium fs-14 pe-5" name="user_email"
                                                    maxLength={10}
                                                    value={userPhoneNumber}
                                                    placeholder="Enter the phone number"
                                                    onChange={(e) => {
                                                        let updatedValue = e?.target?.value;
                                                        updatedValue = updatedValue.replace(/\D/g, "");

                                                        if (updatedValue.length > 10) updatedValue = updatedValue.slice(0, 10);

                                                        if (updatedValue && !/^[6-9]/.test(updatedValue)) return;
                                                        setUserPhoneNumber(e.target.value)
                                                    }}
                                                />
                                                <div className="d-flex justify-content-between mt-3">
                                                    <button type="button" className="loginAddemailModelBtn bg-secondary" onClick={() => setEditModalOpen(false)}>Cancel</button>
                                                    <button type="button" className="loginAddemailModelBtn primary-bg" onClick={handelEditUserMobileNum} disabled={btnloadingStatus}   >
                                                        {btnloadingStatus ? <span className="spinner-border spinner-border-sm" /> : "Done"}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                    </div >
                </div >
            </div>
        </>
    )
};

export default OtpVerification;

